/* Cozyleigh design kit: product pages (phase 4). Styles: assets/cozyleigh-kit-product.css.
   - Status pill on the main product photo (.cl-photo-tape, snippets/cl-photo-tape): follows the status line
     (snippets/ready-to-ship-badge marks itself .is-ready / .is-later / .is-out as the variant changes).
   - Add to cart: after a successful add the button is sealed with tape and reads "Taped into your cart" for a
     moment, then goes back. It rides on the theme's own ajax add (assets/theme.js ProductForm, a jQuery $.post),
     so nothing in that flow changes: we only listen for its ajaxSuccess. Other buttons (the Fa stack builder) call
     CozyleighProduct.seal(btn) themselves.
   - A faint ring ripples out from where an Add to cart button is pressed.
   Honours prefers-reduced-motion. */
(function () {
  if (window.CozyleighProduct) return;
  var still = window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches;
  var TAPED = 'Taped into your cart';
  var ADD_BTNS = '.product-purchase-form button[name="add"], .product-area__add-to-cart-xs button, .cl-seal-btn';

  /* ---------- status pill on the main photo ---------- */
  var WORDS = { ready: 'Ready to ship', order: 'Made for you' };
  function syncTape(area) {
    var tape = area.querySelector('.cl-photo-tape');
    var badge = area.querySelector('[data-rts-badge]');
    if (!tape || !badge || tape.classList.contains('cl-photo-tape--static')) return;
    var state = badge.classList.contains('is-ready') ? 'ready' : badge.classList.contains('is-out') ? 'out' : 'order';
    tape.classList.toggle('cl-photo-tape--off', state === 'out');
    if (state === 'out') return;
    tape.classList.toggle('is-ready', state === 'ready');
    tape.classList.toggle('is-order', state !== 'ready');
    var txt = tape.querySelector('[data-cl-pill-text]') || tape;
    if (txt.textContent !== WORDS[state]) txt.textContent = WORDS[state];
  }
  function watchTapes(scope) {
    [].slice.call((scope || document).querySelectorAll('.product-area')).forEach(function (area) {
      if (area.__clTape || !area.querySelector('[data-rts-badge]')) return;
      area.__clTape = true;
      syncTape(area);
      new MutationObserver(function (list) {
        for (var i = 0; i < list.length; i++) {
          var t = list[i].target;
          if (list[i].type === 'childList' || (t.hasAttribute && t.hasAttribute('data-rts-badge'))) { syncTape(area); return; }
        }
      }).observe(area, { subtree: true, attributes: true, attributeFilter: ['class'], childList: true });
    });
  }

  /* ---------- the tape seal ---------- */
  // opts.ms: how long it stays sealed; opts.restore: the html to go back to (defaults to what was there)
  function seal(btn, opts) {
    if (!btn) return;
    opts = opts || {};
    var restore = opts.restore != null ? opts.restore : (btn.__clRestore != null ? btn.__clRestore : btn.innerHTML);
    btn.__clRestore = restore;
    clearTimeout(btn.__clSealT);
    btn.classList.add('cl-seal-btn');
    btn.classList.remove('cl-packed');
    btn.innerHTML = '<span class="cl-sweep" aria-hidden="true"></span><span class="cl-sweep__txt"></span>';
    btn.querySelector('.cl-sweep__txt').textContent = TAPED;
    void btn.offsetWidth;
    btn.classList.add('cl-packed');
    // if anything else rewrites the label meanwhile (the theme, a re-render), drop the seal with it
    if (btn.__clSealMo) btn.__clSealMo.disconnect();
    btn.__clSealMo = new MutationObserver(function () {
      if (btn.querySelector('.cl-sweep')) return;
      btn.__clSealMo.disconnect(); clearTimeout(btn.__clSealT);
      btn.classList.remove('cl-packed'); btn.__clRestore = null;
    });
    btn.__clSealMo.observe(btn, { childList: true });
    btn.__clSealT = setTimeout(function () {
      btn.__clSealMo.disconnect();
      btn.classList.remove('cl-packed');
      // the theme may already have put its own label back; only undo what is still ours
      if (btn.querySelector('.cl-sweep')) btn.innerHTML = restore;
      btn.__clRestore = null;
    }, opts.ms || 2600);
  }

  // The theme's ProductForm posts with jQuery and, on success, shows "Added to cart" for 4 seconds before putting
  // the original label back. We seal the same button for that same window, so it reverts together with the theme.
  var lastForm = null;
  document.addEventListener('submit', function (e) {
    var f = e.target;
    if (f && f.closest && f.closest('product-form')) lastForm = f;
  }, true);
  function hookAjax() {
    var $ = (window.theme && window.theme.jQuery) || window.jQuery; // the theme keeps its own copy on theme.jQuery
    if (!$ || hookAjax.done) return !!hookAjax.done;
    hookAjax.done = true;
    $(document).on('ajaxSuccess', function (ev, xhr, settings) {
      if (!settings || !/\/cart\/add/.test(settings.url || '') || !lastForm) return;
      var form = lastForm; lastForm = null;
      if (form.classList.contains('feedback-add_and_redirect')) return; // the page is leaving for the cart
      var btn = form.querySelector('button[type="submit"][name="add"]');
      if (!btn) return;
      var orig = $(btn).data('originalHtml');
      seal(btn, { ms: 4000, restore: orig != null ? orig : null });
      var area = form.closest('.product-area');
      var sticky = area && area.querySelector('.product-area__add-to-cart-xs button');
      if (sticky && sticky.hasAttribute('disabled')) {
        var so = $(sticky).data('originalHtml');
        seal(sticky, { ms: 4000, restore: so != null ? so : null });
      }
    });
    return true;
  }

  /* ---------- the ripple ---------- */
  document.addEventListener('pointerdown', function (e) {
    if (still || !e.target.closest) return;
    var b = e.target.closest(ADD_BTNS);
    if (!b || b.disabled) return;
    var r = b.getBoundingClientRect();
    b.classList.add('cl-seal-btn');
    b.style.setProperty('--cl-rx', (e.clientX - r.left) + 'px');
    b.style.setProperty('--cl-ry', (e.clientY - r.top) + 'px');
    b.classList.remove('cl-rippling'); void b.offsetWidth; b.classList.add('cl-rippling');
    clearTimeout(b.__clRingT);
    b.__clRingT = setTimeout(function () { b.classList.remove('cl-rippling'); }, 750);
  }, { passive: true });

  function init(scope) { watchTapes(scope); }
  window.CozyleighProduct = { seal: seal, init: init };

  function start() {
    init(document);
    if (!hookAjax()) { var n = 0, t = setInterval(function () { if (hookAjax() || ++n > 40) clearInterval(t); }, 250); }
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', start); else start();
  document.addEventListener('shopify:section:load', function (e) { init(e.target); });
})();
